import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const StyleDefaultContentWrapper = styled.div<any>`
  height: 100vh;
  width: ${(props: { collapsed: boolean }) =>
    props.collapsed ? 'calc(100% - 60px)' : 'calc(100% - 250px)'};
  transition: width 0.3s ease;
`

export const StyleDefaultHeaderWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
`

export const StyleDefaultMainContentWrapper = styled.div`
  height: calc(100vh - 50px);
  padding: 30px 0px;
  overflow-y: auto;
  background-color: ${(props: any) => props.theme.colors.adminBg};
`

export const StyleDefaultWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;
`
export const StyleSideBarWrapper = styled.div<any>`
  background: ${(props: any) => props.theme.colors.white};
  height: 100vh;
  border-right: 1px solid ${(props: any) => props.theme.colors.grey100};
  display: flex;
  flex-direction: column;
  width: ${(props: any) => (props.collapsed ? 60 : 250)}px;
  transition: width 0.3s ease;
  white-space: nowrap;
  height: '100vh';
`

export const StyleDefaultHeaderRightRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  align-items: center;
  height: 100%;
  margin-left: auto;
`
export const StyleHeaderDropdownBg = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 0px 12px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
`
export const StyleHeaderDropdownItems = styled.ul`
  transition: all 0.5s ease;
`

export const StyleHeaderDropdownItem = styled.li`
  display: flex;
  column-gap: 20px;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 1px solid ${(props: any) => props.theme.colors.borderColor};
  }
  &:last-child {
    border-bottom: none;
  }
`
export const StyleHeaderDropdownWrapper = styled.div`
  position: absolute;
  width: 300px;
  bottom: 0px;
  top: 60px;
  right: 30px;
  z-index: 999;
`

export const StyleHamburger = styled.div<any>`
  display: flex;
  align-items: center;

  justify-content: ${(props: any) =>
    props.collapsed ? 'center' : 'space-between'};

  cursor: 'pointer';

  padding: ${(props: any) => (props?.collapsed ? 12 : 12)}px 10px;
`
export const StyleImageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const StyleSidebaItemLinkWrapper = styled.div<any>`
  display: flex;
  column-gap: 5px;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  padding: 0px 15px;
  background: ${(props: any) =>
    props.isActive ? props.theme.colors.primary50 : 'transparent'};
  color: ${(props: any) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.black500};
  a,
  p {
    color: ${(props: any) =>
      props.isActive
        ? props.theme.colors.primary
        : props.theme.colors.black500};
  }
  :hover {
    background: ${(props: any) => props.theme.colors.primary50};
    color: ${(props: any) => props.theme.colors.primary};
    a,
    p {
      color: ${(props: any) => props.theme.colors.primary};
    }
  }
`

export const StyleSideBarIconLink = styled(Link)<any>`
  display: flex;
  align-items: center;
  height: 40px;
`

export const StyleSidebarItemContentWrapper = styled.div``

export const StyleSidebarItemLink = styled(Link)<any>`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.black500};
  text-decoration: none;
  font-weight: 400;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
`

export const StyleSidebarItemsWrapper = styled.ul<any>`
  transition: all 0.5s ease;
  margin-top: 5px;
  ${(props: any) => props.customStyle}
`

export const StyleSidebarItemTitle = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.black500};
  text-decoration: none;
  font-weight: 400;
  display: block;
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
`

export const StyleSidebarItemWrapper = styled.li`
  margin-top: 5px;
`

export const StyleContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0 32px;

  justify-content: center;

  @media (max-width: 1024px) {
    padding: 0 0 64px;
  }
`
export const StylePublicHeaderBtnWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  /* margin-left: auto; */
`

export const StylePublicHeaderWrapper = styled.div`
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 4px 0px;
  height: 70px;
`

export const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`

export const NavbarContainer = styled.div`
  position: sticky; // or fixed
  top: 0;
  z-index: 100;
  width: 100%;
  background-color: #fff;
`

export const StylePublicFooterWrapper = styled.div`
  margin-top: 120;
  display: flex;
  flex-direction: row;
  padding: 10px 0px;
  align-items: center;
  background-color: ${(props: any) => props.theme.colors.primary50};

  @media (max-width: 1024px) {
    display: none;
  }
`

export const StyleFooterText = styled.p<any>`
  max-width: 500px;
  font-size: 12px;
  color: '#4B4B4B';
  font-weight: 400;
  cursor: ${(props: any) => (props?.noPointer ? 'auto' : 'pointer')};
  ${(props: any) => props.customStyle}
`

export const AnchorLinks = styled.a`
  text-decoration: none;
  color: ${(props: any) => props.theme.colors.primary};
  color: #000;
  cursor: pointer;
  font-size: 12px;
`

export const StylePublicFooterRowWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  row-gap: 10px;
  flex-wrap: wrap;
`

export const StyleNotificationWrapper = styled.div`
  display: flex;
  position: relative;
`

export const StyleNotificationCount = styled.p`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: ${(props: any) => props.theme.colors.red800};
  border-radius: 999px;
  color: #fff;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`
export const StyleNotificationDropdownWrapper = styled.div`
  background-color: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  position: absolute;
  top: 60px;
  z-index: 999;
  border-radius: 12px;
  width: 600px;
  height: 600px;
  right: 2%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
`

export const StyleNotificationHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
export const StyleNotificationBody = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);

  width: 100%;
  overflow-y: auto;
`
export const StyleMainContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 48px;
  padding: 0;
`
export const ValidationSectionWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 50%;
  height: 100%;
  padding: 20px;
  justify-content: center;
`

export const InitialForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const MobileScreenWrapper = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`

export const MediumScreenWrapper = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`
